import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const SecurityLink = ({
  className = "",
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <p className={cn("text-remedium-blue mb-6 text-sm", className)}>
      {children}
    </p>
  );
};
